const transformData = [
    {
        name: 'Family & friends',
        value: 'Item 1',
    },
    {
        name: 'Business Angels',
        value: 'Item 2',
    },
    {
        name: 'Crowdfunding',
        value: 'Item 3',
    },
    {
        name: 'Incubators and Accelerators',
        value: 'Item 4',
    },
    {
        name: 'NGO’s loans',
        value: 'Item 5',
    },
    {
        name: 'NGO’s grants',
        value: 'Item 6',
    },
    {
        name: 'Public subsidies (e.g. tax credits)',
        value: 'Item 7',
    },
    {
        name: 'Public grants',
        value: 'Item 8',
    },
    {
        name: 'Venture capital',
        value: 'Item 9',
    },
    {
        name: 'Microfinance',
        value: 'Item 10',
    },
    {
        name: 'Financial institutions (banks)',
        value: 'Item 11',
    },
    {
        name: 'Other',
        value: 'other',
    },
];

/**
 * Survey: PROJECT - BASELINE IMPACT
 * question: What kind of funds did you try to obtain?
 * 
 * == baseline
 * question19
 * 
 * @param props 
 * @returns 
 */
export const kindFundsObtainedBeforeAccelerationProgramChartCalculation = (props: any) => {
    const data: any = transformData.map(({name, value}) => ({
        name,
        y: props.baselineSubmissions.filter((submission: any) => {
            for (let i = 0; i < 10; i++) {
                if (submission[`question19_${i}`] === value) return true;
            }

            return false;
        }).length
    }));

    return {
        chart: {
            type: 'bar',
        },
        xAxis: {
            categories: transformData.map(({name}) => name),
        },
        plotOptions: {
            bar: {
                dataLabels: {
                    enabled: false,
                },
                groupPadding: 0.1,
            },
        },
        title: {
            text: 'KPI: Kind of Funds obtained before the acceleration program',
            align: 'left',
        },
        series: [
            {
                showInLegend: false,
                type: 'column',
                data,
            },
        ],
    } as Highcharts.Options;
}